module.exports = new __parcel__URL__("markedfordeath.914a5480.png").toString();